import React, {
  useState,
  useEffect,
  Fragment,
  useRef,
  useCallback,
} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  addActivities,
  removeDocumentActivities,
} from "../../actions/DocumentActions/index";
import { ACTIVITY_EVENT_MESSAGE } from "../../constants/activities";
import { formatDate } from "../../utils/globalUtils";

const Activity = ({
  objectId,
  activities,
  addActivities: addActivitiesAction,
  removeDocumentActivities: removeActivities,
  hasMoreActivities,
}) => {
  const activityRef = useRef(null);
  const [loadingMore, setLoadingMore] = useState(false);
  // call when object id changes
  useEffect(() => {
    addActivitiesAction(objectId, null, null, 10, false).catch(() => {});

    return () => {
      // remove activities
      removeActivities();
    };
  }, [addActivitiesAction, objectId, removeActivities]);

  const loadMore = useCallback(() => {
    if (
      activityRef.current.scrollTop + activityRef.current.clientHeight >=
      activityRef.current.scrollHeight
    ) {
      if (hasMoreActivities && !loadingMore) {
        setLoadingMore(true);
        // make api call
        const { timestamp } = activities[activities.length - 1];
        let before = timestamp;
        if (process.env.REACT_APP_ENVIRONMENT === "LOCAL") {
          before = `${timestamp.slice(0, -6)}Z`;
        }
        if (before.length !== 27) {
          before = `${before.slice(0, -1) + "0".repeat(27 - before.length)}Z`;
        }
        addActivitiesAction(objectId, before, null, 10, true)
          .then(() => {
            setLoadingMore(false);
          })
          .catch(() => {
            setLoadingMore(false);
          });
      }
    }
  }, [
    activities,
    addActivitiesAction,
    hasMoreActivities,
    loadingMore,
    objectId,
  ]);

  useEffect(() => {
    // load more
    const activityReference = activityRef.current;
    activityReference.addEventListener("scroll", loadMore);

    return () => activityReference.removeEventListener("scroll", loadMore);
  }, [loadMore]);

  return (
    <div className="context-activity animated fadeinright">
      <div className="activity-header">
        <span className="activity-right-pane-title">Activity</span>
      </div>
      <div className="activity-content">
        <div className="activity-content-scroll" ref={activityRef}>
          <div className="activity-info">
            This is a record of all activities associated with this document.
          </div>
          {/* <div className="activity-section-title">
            This is not there, also change class names
          </div> */}
          {activities && activities.length ? (
            activities.map(
              ({ actor, event, timestamp, subjects, meta_info }) => (
                <Fragment>
                  {ACTIVITY_EVENT_MESSAGE[event] ? (
                    <div className="activity-users">
                      <div className="activities-event-icon">
                        {" "}
                        {(meta_info && meta_info.to_lane) ||
                        event === "DOCUMENT_AUTO_ESIGNED" ||
                        event === "ESIGN_LINK_EXPIRY_EXTENDED" ? (
                          <span className={`activity-check ${event}`}>
                            <FontAwesomeIcon icon={["far", "cog"]} />
                          </span>
                        ) : (
                          <span className={`activity-check ${event}`}>
                            <FontAwesomeIcon icon={["far", "check"]} />
                          </span>
                        )}
                        <div className="activities-date">
                          {formatDate(timestamp, "lll")}
                        </div>
                      </div>
                      <div className="activities-user-card">
                        <div className="activity-user-imgwrapper">
                          <img
                            className="activity-user-img"
                            src={actor.image_url}
                            alt=""
                          />
                        </div>
                        <div className="activity-event-wrapper">
                          <span className="activity-user-name">
                            {actor.name}
                          </span>
                          <span className="activity-user-email">
                            {actor.user_email}
                          </span>
                          <span className="activity-user-event">
                            {ACTIVITY_EVENT_MESSAGE[event] &&
                              ACTIVITY_EVENT_MESSAGE[event](
                                Array.isArray(subjects) && subjects.length > 0
                                  ? subjects
                                  : meta_info,
                              )}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    console.debug(`${event} event is not handled`)
                  )}
                </Fragment>
              ),
            )
          ) : (
            <div className="activity-no-users-message">No activities</div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ DocumentStore }) => {
  const {
    document: { objectId = "" } = {},
    activities,
    hasMoreActivities,
  } = DocumentStore;

  return {
    objectId,
    activities,
    hasMoreActivities,
  };
};

Activity.defaultProps = {
  activities: [],
};

Activity.propTypes = {
  objectId: PropTypes.string.isRequired,
  addActivities: PropTypes.func.isRequired,
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      event: PropTypes.string.isRequired,
      timestamp: PropTypes.string.isRequired,
      actor: PropTypes.shape({
        name: PropTypes.string.isRequired,
        user_email: PropTypes.string.isRequired,
        image_url: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ),
  hasMoreActivities: PropTypes.bool.isRequired,
};

const mapDispatchToProps = {
  addActivities,
  removeDocumentActivities,
};

export default connect(mapStateToProps, mapDispatchToProps)(Activity);
